var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"u-heading has-padding-bottom-50 has-border-bottom"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.isBusiness ? "_.company_details" : "_.billing_address"))+"\n  ")]),_vm._v(" "),_c('div',{class:[
      'box',
      'has-background-light',
      'is-borderless',
      'is-shadowless',
      'has-margin-bottom-100'
    ]},[_c('div',{class:[
        'is-spaced-apart',
        _vm.basketData.basketIsProcessing
          ? 'has-cursor-wait'
          : 'has-cursor-pointer'
      ],on:{"click":_vm.onToggle}},[_c('i18n',{staticClass:"has-cursor-pointer",attrs:{"path":"_sentence.business_buying_condition","tag":"p"}},[_c('i18n',{attrs:{"slot":"condition","path":_vm.isBusiness ? '_.yes' : '_.no',"tag":"strong"},slot:"condition"})],1),_vm._v(" "),_c('b-switch',{class:[_vm.basketData.basketIsProcessing && 'has-cursor-wait'],attrs:{"value":_vm.isBusiness,"type":"is-success"},nativeOn:{"click":function($event){$event.preventDefault();}}})],1)]),_vm._v(" "),(_vm.isBusiness)?_c('basket-companies'):_c('basket-addresses')],1)}
var staticRenderFns = []

export { render, staticRenderFns }